import { PortalActions } from "@mongez/react-atom";
import { cn } from "~/design-system/lib/utils";
import { IconProps } from "~/design-system/types";

type CloseIconProps = {
  portal: PortalActions;
} & IconProps;

export function PortalCloseIcon({ portal, ...props }: CloseIconProps) {
  return (
    <svg
      width="44"
      height="45"
      viewBox="0 0 44 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      onClick={portal.close}
      className={cn("cursor-pointer", props.className)}
    >
      <rect x="0.5" y="1" width="43" height="43" rx="21.5" fill="white" />
      <rect x="0.5" y="1" width="43" height="43" rx="21.5" stroke="#E6E6E6" />
      <g clipPath="url(#clip0_382_24032)">
        <path
          d="M15.6622 26.8517C15.4689 27.0439 15.3602 27.3055 15.3602 27.579C15.3602 27.8525 15.4689 28.1154 15.6622 28.31C15.8556 28.5047 16.1179 28.615 16.3914 28.6167C16.6649 28.6184 16.9272 28.5114 17.1205 28.3193L22.2246 23.2474L27.3287 28.3839C27.5221 28.5785 27.7843 28.6888 28.0578 28.6905C28.3313 28.6922 28.5936 28.5852 28.787 28.3931C28.9804 28.2009 29.089 27.9393 29.089 27.6658C29.089 27.3923 28.9804 27.1294 28.787 26.9347L23.6829 21.7983L28.787 16.7264C28.9804 16.5343 29.089 16.2726 29.089 15.9992C29.089 15.7257 28.9804 15.4627 28.787 15.2681C28.5936 15.0735 28.3313 14.9632 28.0578 14.9614C27.7843 14.9597 27.5221 15.0667 27.3287 15.2589L22.2246 20.3307L17.1205 15.1943C16.9272 14.9997 16.6649 14.8894 16.3914 14.8876C16.1179 14.8859 15.8556 14.9929 15.6622 15.185C15.4689 15.3772 15.3602 15.6388 15.3602 15.9123C15.3602 16.1858 15.4689 16.4488 15.6622 16.6434L20.7663 21.7798L15.6622 26.8517Z"
          fill="#0083C3"
        />
      </g>
      <defs>
        <clipPath id="clip0_382_24032">
          <rect
            width="26.9549"
            height="20.6027"
            fill="white"
            transform="translate(20 5.5) rotate(45.1812)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
